import { asyncAction } from 'lib/actionCreators'

export const parsedResumesList = asyncAction('recruiter/PARSED_RESUMES_LIST')
export const newParsedResumesList = asyncAction('recruiter/NEW_PARSED_RESUMES_LIST')
export const forceAddResumeToQueue = asyncAction('recruiter/FORCE_ADD_RESUME_TO_QUEUE')
export const removeResumeFromQueue = asyncAction('recruiter/REMOVE_RESUME_FROM_QUEUE')
